import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";
import docCookies from "cookies.js";
Alpine.plugin(intersect);
Alpine.plugin(collapse);
window.Alpine = Alpine;
// const getTop = (el) =>
//   el.offsetTop + (el.offsetParent && getTop(el.offsetParent));
function updateInnerHTML(data, selector, url) {
  const html = new DOMParser().parseFromString(data, "text/html");
  const html_dom = html.querySelector(selector).innerHTML;
  const html_selecor = document.querySelector(selector);
  // if (window.matchMedia("(min-width: 1024px)").matches) {
  //   window.scrollTo({
  //     top: getTop(html_selecor.closest('#collection-section')),
  //     behavior: "smooth",
  //   });
  // }
  html_selecor.innerHTML = html_dom;
  history.replaceState(null, '', url);
}

function updateUrlWithFormParams(currentUrl, options = {}) {
  const url = new URL(currentUrl);
  const sortBy = url.searchParams.get("sort_by");
  if (options.filterForm) {
    const formData = new FormData(options.filterForm);
    const formQueryString = new URLSearchParams(formData).toString();
    const searchParams = new URLSearchParams(formQueryString);
    if (sortBy !== null) {
      searchParams.set("sort_by", sortBy);
    }
    url.search = searchParams.toString();
  } else if (options.sortBy) {
    const searchParams = url.searchParams;
    searchParams.set("sort_by", options.sortBy);
    url.search = searchParams.toString();
  }
  return url;
}

Alpine.data("accordion", (id) => ({
  id: id,
  get expanded() {
    return this.active === this.id;
  },
  set expanded(value) {
    this.active = value ? this.id : null;
  },
}));

Alpine.data("cartFn", (initialState = "cart") => ({
  type: initialState,
  showCartDrawer: false,
  loading: false,
  updateCart() {
    this.loading = true;
    fetch(`/?view=${this.type}`)
      .then((response) => response.text())
      .then((cartData) => {
        const html = new DOMParser().parseFromString(cartData, "text/html");
        this.$refs.cart_content.innerHTML = cartData;
        const cartCount = JSON.parse(
          html.querySelector("[data-options]").innerHTML
        ).item_count;
        this.$dispatch("cart-count-updated", cartCount);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
}));
Alpine.data("filterFn", () => ({
  loading: false,
  filterCollection() {
    this.loading = true;
    // Fetch the new data based on the updated URL
    const updatedUrl = updateUrlWithFormParams(window.location.href, { filterForm: this.$refs.filter_form });
    fetch(updateUrlWithFormParams(updatedUrl))
      .then((response) => response.text())
      .then((filteredData) => {
        updateInnerHTML(filteredData, '#product-grid', updatedUrl)
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => (this.loading = false));
  },
  resetCollection() {
    this.loading = true;
    let url = new URL(window.location.href);
    url.search = "";
    const updatedUrl = updateUrlWithFormParams(url);
    // Fetch the new data based on the updated URL
    fetch(updatedUrl)
      .then((response) => response.text())
      .then((filteredData) => {
        updateInnerHTML(filteredData, '#product-grid', updatedUrl)
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => (this.loading = false));
  }
}));

// Alpine.data("sortFn", (initialState, collection) => ({
//   loading: false,
//   handle: collection,
//   sort: initialState,
//   sortCollection() {
//     this.loading = true;
//     const updatedUrl = updateUrlWithFormParams(window.location.href, { sortBy: this.sort });
//     // Fetch the new data based on the updated URL
//     fetch(updateUrlWithFormParams(updatedUrl))
//       .then((response) => response.text())
//       .then((sortData) => {
//         updateInnerHTML(sortData, '#product-grid', updatedUrl)
//       })
//       .catch((error) => console.error("Error:", error))
//       .finally(() => (this.loading = false));
//   },
// }));

Alpine.data("announcementFn", (cookiename) => ({
  init() {
    this.hide_announcement = docCookies.hasItem(cookiename);
    // console.log(this.hide_announcement)
  },
  hide_announcement: false,
  dismiss() {
    this.hide_announcement = true;
    docCookies.setItem(cookiename, true, (60*24*60*60))
  }
}))

// Staggered reveal: elements entering the viewport in the same frame are
// sorted by position and get --i from 0, so the delay depends on what is
// visible together, not on the element's index in the whole list.
const revealQueue = [];
let revealFrame = null;
const flushReveal = () => {
  revealFrame = null;
  revealQueue
    .sort((a, b) =>
      Math.round(a.boundingClientRect.top - b.boundingClientRect.top) ||
      a.boundingClientRect.left - b.boundingClientRect.left)
    .forEach((entry, i) => {
      entry.target.style.setProperty("--i", i);
      entry.target.dataset.inview = "true";
    });
  revealQueue.length = 0;
};
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    revealObserver.unobserve(entry.target);
    revealQueue.push(entry);
  });
  if (revealQueue.length && !revealFrame) revealFrame = requestAnimationFrame(flushReveal);
}, { threshold: 0.25 });

Alpine.directive("reveal", (el, {}, { cleanup }) => {
  revealObserver.observe(el);
  cleanup(() => revealObserver.unobserve(el));
});
Alpine.start();

let StudioRemo = {
  updateQuantity(line, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: qty, line: line }),
    })
      .then((response) => response.json())
      .then((data) => {
        // fire javascript event on window
        window.dispatchEvent(new Event("cart-updated"));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
};

window.StudioRemo = StudioRemo;
